let countdown;
function timer(seconds) {
    const now = Date.now();
    const then = now + seconds * 1000;
    displayTimeLeft(seconds);
    countdown = setInterval(()=>{
        const secondsLeft = Math.round((then - Date.now()) / 1000);
        if (secondsLeft < 0) {
            clearInterval(countdown);
            return;
        }
        displayTimeLeft(secondsLeft);
    }, 1000);
}
function displayTimeLeft(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainderSeconds = seconds % 60;
    const display = `${minutes}:${remainderSeconds < 10 ? "0" : ""}${remainderSeconds}`;
    document.getElementById("time").textContent = display;
}
document.getElementById("start").addEventListener("click", ()=>{
    const duration = 1500; // 25 minutes
    timer(duration);
//   document.querySelector('#timer-circle circle').style.animationDuration = `${duration}s`;
});

//# sourceMappingURL=index.b2ba01c5.js.map
